import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Layout } from './components/Layout';
import { CallDock } from './components/CallDock';
import { LoadingBlock } from './components/ui';
import { useAuth } from './lib/auth';
import { CallSessionProvider } from './lib/call-session';

import { LoginPage } from './pages/Login';
import { DashboardPage } from './pages/Dashboard';
import { TicketsPage } from './pages/Tickets';
import { TicketFormPage } from './pages/TicketForm';
import { TicketDetailPage } from './pages/TicketDetail';
import { ChangeRequestsPage } from './pages/ChangeRequests';
import { ChangeRequestFormPage } from './pages/ChangeRequestForm';
import { ChangeRequestDetailPage } from './pages/ChangeRequestDetail';
import { ComplaintsPage } from './pages/Complaints';
import { ComplaintFormPage } from './pages/ComplaintForm';
import { ComplaintDetailPage } from './pages/ComplaintDetail';
import { CallsPage } from './pages/Calls';
import { CallAddPage } from './pages/CallAdd';
import { CallDetailPage } from './pages/CallDetail';
import { AccountPage } from './pages/Account';
import { NotFoundPage } from './pages/NotFound';
import { SharePage } from './pages/Share';
import { MeetPage } from './pages/Meet';
import { BookingPage } from './pages/Booking';

export function App() {
  const { account, loading } = useAuth();
  const { pathname } = useLocation();

  // A Viganium Drive link's page is open to anyone who has the link, signed in or not (2026-11-02).
  if (pathname.startsWith('/share/')) {
    return (
      <Routes>
        <Route path="/share/:token" element={<SharePage />} />
        <Route path="*" element={<SharePage />} />
      </Routes>
    );
  }

  // A booking link's page, and a guest's own booking, are open to anyone with the link too (2026-11-05).
  if (pathname.startsWith('/meet/') || pathname.startsWith('/booking/')) {
    return (
      <Routes>
        <Route path="/meet/:token" element={<MeetPage />} />
        <Route path="/booking/:token" element={<BookingPage />} />
        <Route path="*" element={<MeetPage />} />
      </Routes>
    );
  }

  if (loading) {
    return (
      <div className="grid h-full place-items-center">
        <LoadingBlock />
      </div>
    );
  }

  if (!account) return <LoginPage />;

  return (
    // The call goes on whatever page the client moves to (2026-11-01): the session and its dock sit above the pages.
    <CallSessionProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          {/* Form routes come before `:id` so "new" is never read as an id. */}
          <Route path="/tickets" element={<TicketsPage />} />
          <Route path="/tickets/new" element={<TicketFormPage />} />
          <Route path="/tickets/:id" element={<TicketDetailPage />} />
          <Route path="/change-requests" element={<ChangeRequestsPage />} />
          <Route path="/change-requests/new" element={<ChangeRequestFormPage />} />
          <Route path="/change-requests/:id" element={<ChangeRequestDetailPage />} />
          <Route path="/complaints" element={<ComplaintsPage />} />
          <Route path="/complaints/new" element={<ComplaintFormPage />} />
          <Route path="/complaints/:id" element={<ComplaintDetailPage />} />
          <Route path="/calls" element={<CallsPage />} />
          <Route path="/calls/add" element={<CallAddPage />} />
          <Route path="/calls/:id" element={<CallDetailPage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/login" element={<Navigate to="/" replace />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Layout>
      <CallDock />
    </CallSessionProvider>
  );
}
